import React from 'react';
import { Progress } from '@/components/ui/progress';
import { cn } from '@/lib/utils';
import { useRagThresholds, getRagAccent } from '@/hooks/useRagThresholds';

interface MatchScoreBarProps {
  score: number;
  className?: string;
}

export function MatchScoreBar({ score, className }: MatchScoreBarProps) {
  const thresholds = useRagThresholds();
  const accent = getRagAccent(score, thresholds);
  return (
    <Progress
      variant="mini"
      value={score}
      accent={accent}
      className={cn(className)}
      aria-label={`Match score: ${score}%`}
      aria-valuenow={score}
      aria-valuemin={0}
      aria-valuemax={100}
    />
  );
}
